import React, { useEffect, useState } from "react";
import {  MenuItem } from "@material-ui/core";
import { SelectValidator } from 'react-material-ui-form-validator';
import { fetchConToken } from "../../helpers/fetch";
import { useSelector } from "react-redux";

const urlBase = process.env.REACT_APP_URL

export const CboNacionalidades = (props) => {
  const { usuarioAutogestion } = useSelector(state => state.userAutogestion);

  const [listaNac, setListaNac] = useState([]);

  useEffect(() => {
    const traerDatos = async () => {
      const response = await fetchConToken(`nacionalidades`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (lista) {
          let nacsFromApi = lista.map((nac) => {
            return {
              value: nac.id_nacionalidad,
              display: nac.descripcion_nacionalidad,
            };
          });
          setListaNac(nacsFromApi);
        }
      }
    };

    const traerDatosAutogestion = async () => {
      fetch(`${urlBase}/api/nacionalidades`, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + usuarioAutogestion.token } })
        .then(res => res.json())
        .then(res => {
          if (res.length > 0) {
            let nacsFromApi = res.map((nac) => {
              return {
                value: nac.id_nacionalidad,
                display: nac.descripcion_nacionalidad,
              };
            });
            setListaNac(nacsFromApi);
          }
        })
    };

    if (Object.keys(usuarioAutogestion).length !== 0) {
      traerDatosAutogestion();
    } else {
      traerDatos();
    }
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <SelectValidator
        value={listaNac?.length > 0 ? props.valor || '' : ''}
        disabled={props.disabled}
        onChange={(e) => {
          props.manejadorInputChange(e);
        }}
        label="Nacionalidad"
        name="id_nacionalidad"
        margin="normal"
        fullWidth={true}
        validators={['required']}
        errorMessages={['Seleccione una opción']}
      >
        <MenuItem value="">
          <em>Seleccione</em>
        </MenuItem>
        {listaNac.map((nac) => (
          <MenuItem key={nac.value} value={nac.value}>
            {nac.display}
          </MenuItem>
        ))}
      </SelectValidator>
    </>
  );
};
